const MetricItem = ({ label, value, tooltip, valueColor, icon }) => (
  <div 
    className="bg-gray-50 rounded-lg p-2 text-center"
    title={tooltip}
  >
    <p className="text-xs text-gray-500 mb-1">
      {icon && <span className="mr-1">{icon}</span>}
      {label}
    </p>
    <p 
      className="font-bold text-lg"
      style={{ color: valueColor || '#1f2937' }}
    >
      {value}
    </p>
  </div>
)

const MetricsGrid = ({ metrics, columns = 3, className = '' }) => {
  const gridColsClass = {
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
  }[columns] || 'grid-cols-3'

  return (
    <div className={`grid gap-3 ${gridColsClass} ${className}`}>
      {metrics.map((metric, index) => (
        <MetricItem
          key={index}
          label={metric.label}
          value={metric.value}
          tooltip={metric.tooltip}
          valueColor={metric.valueColor}
          icon={metric.icon}
        />
      ))}
    </div>
  )
}

export default MetricsGrid

